<template>
    <VJoyWrapper no-margin row-gap="1" column-gap="3" class="profile-information">
        <ProfilePrice v-if="price" :price="price" :tooltip-text="tooltipPrice" />
        <template v-if="location">
            <ProfileLocationGlobalMatching
                v-if="globalMatchingEnabled"
                :location="location"
                :first-name="firstName"
                :target-city="targetCity"
                :compact-mode="compactMode"
            />
            <ProfileLocation v-else-if="location.city" :location="location" :first-name="firstName" :target-city="targetCity" />
        </template>
        <template v-if="stats && !stats.invalidatedCharter">
            <ProfileRating
                v-if="stats.rating && stats.appraisalsWithRatesCount"
                :rating="stats.rating"
                :appraisals-with-rates-count="stats.appraisalsWithRatesCount"
            />
            <ProfileRecommendations v-else-if="stats.recommendationsCount" :recommendations-count="stats.recommendationsCount" />
        </template>
    </VJoyWrapper>
</template>

<script setup lang="ts">
    import {VJoyWrapper} from '@maltjoy/core-vue';
    import ProfileLocation from './ProfileLocation.vue';
    import ProfileLocationGlobalMatching from './ProfileLocationGlobalMatching.vue';
    import ProfilePrice from './ProfilePrice.vue';
    import ProfileRating from './ProfileRating.vue';
    import ProfileRecommendations from './ProfileRecommendations.vue';
    import type {Profile} from '../types';

    defineProps<{
        price?: Profile['price'];
        location?: Profile['location'];
        stats?: Profile['stats'];
        globalMatchingEnabled: boolean;
        firstName: string;
        targetCity?: string;
        compactMode?: boolean;
        tooltipPrice?: string;
    }>();
</script>

<style scoped lang="scss">
    .profile-information {
        font-size: var(--joy-font-size-primary-300);
    }
</style>
